import { CommentThread } from '@pwc/pwc-deals-web-common';

export type CommentCounts = {
  contentId: number;
  resolved: number;
  unresolved: number;
};

export type UseCommentCountsParams = {
  isShared: boolean;
  viewingStatus: 'unresolved' | 'resolved';
  isPanelOpened: boolean;
};

export type GetCommentCountsByVersionsReturnType = {
  contentId: number;
  resolvedDraftThreadCount: number;
  unresolvedDraftThreadCount: number;
  resolvedSharedThreadCount: number;
  unresolvedSharedThreadCount: number;
};

export enum CommentViewStatus {
  Unresolved = 'unresolved',
  Resolved = 'resolved',
}
export type CommentThreatsSubscription = {
  data: {
    commentThreads: Array<CommentThread>;
    metadata?: Partial<{
      commentThreadsState?: {
        isLoading: boolean;
        isSuccess: boolean;
        isError: boolean;
      };
      viewingStatus: CommentViewStatus;
    }>;
  };
};

export type CommentThreadsState = {
  threads: Array<CommentThread>;
  threadsState?: {
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
  };
  viewingStatus?: CommentViewStatus;
};
